module.exports = __webpack_public_path__ + "static/media/Bean-Eater.f1bbe351.gif";